import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var composeRepeatRule = function composeRepeatRule(conf) {
  return "repeat(\n  ".concat(conf.autoFit ? 'auto-fit' : conf.columnsCount, ",\n  minmax(").concat(conf.itemMinSize ? "".concat(conf.itemMinSize, "px") : 'auto', ", 1fr)\n)");
};
export var ColumnGrid = function ColumnGrid(_ref) {
  var children = _ref.children,
    className = _ref.className,
    repeatConf = _ref.repeatConf,
    _ref$template = _ref.template,
    template = _ref$template === void 0 ? [] : _ref$template,
    useRepeat = _ref.useRepeat;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('component', className),
    style: {
      gridTemplateColumns: useRepeat ? composeRepeatRule(repeatConf) : template.join(' ')
    }
  }, children);
};